import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, CarFrontIcon, RouteIcon } from 'lucide-react';
const steps = [{
  icon: SearchIcon,
  title: 'Pick your trip',
  text: 'Choose airport, destination or city tour, then set your pickup and day or night shift.'
}, {
  icon: CarFrontIcon,
  title: 'Choose your car',
  text: 'Compare sedans, SUVs, jeeps and Hiace vans with clear day and night pricing.'
}, {
  icon: RouteIcon,
  title: 'Ride with a driver',
  text: 'A verified driver arrives on time and takes you wherever you need to go.'
}];
export function HowItWorks() {
  return <section id="how" className="w-full bg-white py-16 sm:py-20" data-id="element-273" data-mp="crgh0o6tgwms">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-274" data-mp="gsryg6fjebjw">
        <div className="max-w-2xl" data-id="element-275" data-mp="grgtw4e9ozrq">
          <h2 className="font-display text-3xl font-800 text-ink" data-id="element-276" data-mp="14im8yhcdvo0z">How it works</h2>
          <p className="mt-3 text-ink-soft" data-id="element-277" data-mp="199umnpkqxvjy">Book a ride in three simple steps.</p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-278" data-mp="2rlo07jjtaz11">
          {steps.map((s, i) => {
          const Icon = s.icon;
          return <motion.div key={s.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="relative rounded-2xl bg-slate-50 p-6" data-id="element-279" data-mp="2mnw4sfjykus3" data-mpi={i}>
                <span className="absolute right-5 top-5 font-display text-4xl font-800 text-slate-200" data-id="element-280" data-mp="36au4hlxibffs">
                  {i + 1}
                </span>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-500 text-white" data-id="element-281" data-mp="3k9k4pafmhv8d">
                  <Icon className="h-6 w-6" data-id="element-282" data-mp="3f95rzf32tx40" />
                </span>
                <h3 className="mt-4 font-display text-lg font-700 text-ink" data-id="element-283" data-mp="1px3r1okhzeth">{s.title}</h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-284" data-mp="1ky97ulimbo8u">{s.text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}